export const ReadingLevelOptions = [
    { value: "Pre-School", label: "Pre-School" },
    { value: "1st Grade", label: "1st Grade" },
    { value: "2nd Grade", label: "2nd Grade" },
    { value: "3rd Grade", label: "3rd Grade" },
    { value: "4th Grade", label: "4th Grade" },
    { value: "5th Grade", label: "5th Grade" },
];